module.exports = __webpack_public_path__ + "static/media/loading.ab7a6f85.svg";